"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyIssue = void 0;
var create_entity_1 = require("../../utils/create-entity");
var key_issue_card_1 = require("../../components/entities/key-issue-card");
var key_issue_details_layout_1 = require("../../components/entities/key-issue-details-layout");
var graphql_1 = require("../../utils/graphql");
exports.KeyIssue = {
  name: 'KeyIssue',
  autoRoutes: ['list', 'details', 'create', 'update'],
  type: 'taxonomy',
  usePublishStatus: true,
  groupName: process.env.TAXONOMIES_LABEL || "Challenges & Goals",
  includeInSearch: true,
  useConversation: true,
  useConnections: true,
  usePermissions: true,
  useSlices: true,
  useSpaces: true,
  // useNetwork: true,
  useSiteSlug: true,
  useFollowers: true,
  useModerators: true,
  canEmbed: true,
  usePlatformActivity: true,
  components: {
    card: key_issue_card_1.KeyIssueCard,
    details: key_issue_details_layout_1.KeyIssueDetailsLayout
  },
  table: {
    fieldNames: ["info", "challenge", "createdBy"]
  },
  select: {
    maxWidth: '800px',
    queryFields: "description { id text }"
  },
  list: {
    resultsVariant: 'grid',
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      sid\n      description {\n        id\n        html\n      }\n      influencingFactorsOutgoing {\n        id\n        sid\n        slug\n        name\n      }\n      influencingFactorsIncoming {\n        id\n        sid\n        slug\n        name\n      }\n      organisations { id }\n      feedEntries { id }\n      createdBy { ...CreatorFields }\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      challenge { id name slug }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      createdBy { ...CreatorFields }\n      description { id plain }\n      expertise {\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        person { ...EntityValueFields }\n      }\n      events { ...EntityValueFields }\n      sessions { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      posts { ...EntityValueFields }\n      pages { ...EntityValueFields }\n      courses { ...EntityValueFields }\n      lessons { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      feeds { ...EntityValueFields }\n      videos { url ...EntityValueFields }\n    "], ["\n      sid\n      description {\n        id\n        html\n      }\n      influencingFactorsOutgoing {\n        id\n        sid\n        slug\n        name\n      }\n      influencingFactorsIncoming {\n        id\n        sid\n        slug\n        name\n      }\n      organisations { id }\n      feedEntries { id }\n      createdBy { ...CreatorFields }\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n      challenge { id name slug }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      createdBy { ...CreatorFields }\n      description { id plain }\n      expertise {\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        person { ...EntityValueFields }\n      }\n      events { ...EntityValueFields }\n      sessions { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      feedEntries { ...EntityValueFields }\n      posts { ...EntityValueFields }\n      pages { ...EntityValueFields }\n      courses { ...EntityValueFields }\n      lessons { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      feeds { ...EntityValueFields }\n      videos { url ...EntityValueFields }\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      organisations { ...EntityValueFields }\n      people { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      feedEntries { ...EntityValueFields published }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { id text }\n      parent { ...EntityValueFields }\n      challenge { id name slug description { id text html } openGraph { id image { id url } } }\n      influencingFactorsIncoming { id name slug }\n      influencingFactorsOutgoing { id name slug }\n    "], ["\n      organisations { ...EntityValueFields }\n      people { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      feedEntries { ...EntityValueFields published }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { id text }\n      parent { ...EntityValueFields }\n      challenge { id name slug description { id text html } openGraph { id image { id url } } }\n      influencingFactorsIncoming { id name slug }\n      influencingFactorsOutgoing { id name slug }\n    "])))
  },
  form: {
    modal: {
      fill: true,
      maxWidth: '900px'
    },
    bufferAtEnd: 400,
    // TODO - add this automatically when a select box field is the last field in a set
    fieldSets: [{
      name: "overview"
    }, {
      name: "connections"
    }, {
      name: "images"
    }, {
      name: "data"
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'description',
        useCompletions: true
      },
      challenge: {
        type: 'linked',
        fieldSet: 'taxonomies',
        entityTypeName: 'Challenge'
      },
      parent: {
        type: 'parent'
      },
      banner: {
        type: 'banner'
      },
      dataSetId: {
        type: 'text',
        recommended: false,
        description: "Specify an ID to uniquely identify this {{KEY_ISSUE}}. This might be useful to tie this {{KEY_ISSUE}} to values coming from an external API, for example",
        monospace: true
      },
      influencingFactorsOutgoing: {
        type: 'linkedMultiple',
        entityTypeName: 'InfluencingFactor',
        fieldSet: 'taxonomies',
        label: '{{INFLUENCING_FACTORS}} (Outbound)'
      },
      influencingFactorsIncoming: {
        type: 'linkedMultiple',
        entityTypeName: 'InfluencingFactor',
        fieldSet: 'taxonomies',
        label: '{{INFLUENCING_FACTORS}} (Inbound)',
        description: 'Are there any inbound {{INFLUENCING_FACTORS}}? By selecting {{A_INFLUENCING_FACTOR}} which is outbound from another {{KEY_ISSUE}}, you can connect that other {{KEY_ISSUE}} to this one.'
      },
      indicatorResults: {
        type: 'linkedTable',
        entityTypeName: 'IndicatorResult',
        fieldSet: 'data'
      },
      icons: {
        type: 'linkedMultiple',
        entityTypeName: 'Icon',
        description: 'Select one or more {{ICONS}} to represent this {{KEY_ISSUE}}'
      },
      banners: {
        type: 'linkedMultiple',
        entityTypeName: 'Banner',
        description: "Does this {{KEY_ISSUE}} have any other {{BANNERS}}? This is useful for assigning {{BANNERS}} for different {{SITES}}"
      },
      backgroundImages: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        label: 'Background Images',
        description: "Does this {{KEY_ISSUE}} have any background images?"
      },
      colors: {
        type: 'linkedMultiple',
        entityTypeName: 'Color',
        description: "Does this {{KEY_ISSUE}} have any associated {{COLORS}}?"
      }
    })
  }
};
var templateObject_1, templateObject_2;